function loadImage(uri)
{
    return new Promise(resolve => {

        const img = document.createElement("img")
        img.onload = () => resolve(img)
        img.src = uri;
    })
}


function extractName(uri)
{
    const m = /media\/(.*)\.png/.exec(uri)

    if (!m)
    {
        throw new Error("non conforming uri: " + uri)
    }

    return m[1]

}


export default function loadImages(uris)
{
    
    return Promise.all(
        uris.map(uri => loadImage(uri))
    ).then(
        images => {

            const map = new Map()


            images.forEach((image, idx) => map.set(extractName(uris[idx]), image));

            return map
        }
    )

}
